import React from 'react';
import CustomAddPage from 'components/custom-pages/CustomAddPage';

const Add = ({ data, handleClick }) => {
  const initialValues = {
    name: data?.name || '',
  };

  const inputFields = [
    {
      name: 'name',
      label: 'Tyre Replacement Reason',
      type: 'text',
      required: true,
    },
  ];

  return (
    <CustomAddPage
      pageTitle={
        data ? 'Update Tyre Replacement Reason' : 'Add Tyre Replacement Reason'
      }
      url={'tyre-replacement-reason'}
      action={!data ? 'create' : 'update'}
      updateId={data?._id}
      queryKey="tyre-replacement-reason"
      inputFields={inputFields}
      data={initialValues}
      handleClick={handleClick}
    />
  );
};

export default Add;
